<template>
  <van-popup
    v-model="show"
    round
    position="center"
    :close-on-click-overlay="false"
    class="time-error-dialog"
    @closed="handleClosed"
  >
    <div class="time-error-dialog__body">
      <div class="time-error-dialog__title">手机时间不准确</div>
      <p class="time-error-dialog__desc">
        检测到您的手机时间与服务器时间不一致，请调整手机时间后重试。
      </p>
      <div class="time-error-dialog__imgs">
        <img :src="img1" alt="调整手机时间步骤一" />
        <img :src="img2" alt="调整手机时间步骤二" />
      </div>
      <van-button type="info" block round @click="close">我知道了</van-button>
    </div>
  </van-popup>
</template>

<script>
import Vue from 'vue';
import img1 from '@/assets/调整移动端时间1.png';
import img2 from '@/assets/调整移动端时间2.png';

const TimeErrorDialog = {
  name: 'TimeErrorDialog',
  data() {
    return {
      show: false,
      img1,
      img2,
    };
  },
  mounted() {
    // 挂载后再打开，保证弹出过渡动画生效
    this.$nextTick(() => {
      this.show = true;
    });
  },
  methods: {
    close() {
      this.show = false;
    },
    handleClosed() {
      this.$emit('close');
    },
  },
};

// 弹窗单例：并发请求同时返回 304 时只保留一个弹窗
let instance = null;

/**
 * 命令式弹出「手机时间不准确」提示弹窗（可在非组件环境，如 axios 拦截器中调用）
 */
export function showTimeErrorDialog() {
  if (instance) {
    instance.show = true;
    return instance;
  }
  const Comp = Vue.extend(TimeErrorDialog);
  instance = new Comp();
  instance.$on('close', () => {
    instance.$destroy();
    if (instance.$el && instance.$el.parentNode) {
      instance.$el.parentNode.removeChild(instance.$el);
    }
    instance = null;
  });
  instance.$mount();
  document.body.appendChild(instance.$el);
  return instance;
}

export default TimeErrorDialog;
</script>

<style lang="less" scoped>
.time-error-dialog {
  width: 86%;
  max-width: 420px;

  &__body {
    padding: 20px 16px 16px;
  }

  &__title {
    font-size: 17px;
    font-weight: 600;
    color: #323233;
    text-align: center;
  }

  &__desc {
    margin: 8px 0 12px;
    font-size: 13px;
    line-height: 1.5;
    color: #646566;
    text-align: center;
  }

  &__imgs {
    margin-bottom: 16px;
    max-height: 50vh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;

    img {
      display: block;
      width: 100%;
      height: auto;
      border-radius: 6px;

      & + img {
        margin-top: 10px;
      }
    }
  }
}
</style>
